import { render, staticRenderFns } from "./StdCenterModal.vue?vue&type=template&id=0b43a85e&"
import script from "./StdCenterModal.vue?vue&type=script&lang=js&"
export * from "./StdCenterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports